/* Pip & Moon — theme behaviour. Shopify AJAX Cart API + Section Rendering API. */
(function () {
  'use strict';

  var PM = window.PM || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = PM.rootUrl && PM.rootUrl !== '/' ? PM.rootUrl.replace(/\/$/, '') : '';

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---------------- scrim / overlays ---------------- */
  var openLayers = [];
  function scrimOn() { var s = $('#scrim'); if (s) s.classList.add('is-on'); document.body.classList.add('no-scroll'); }
  function scrimOff() { var s = $('#scrim'); if (s) s.classList.remove('is-on'); document.body.classList.remove('no-scroll'); }

  function openLayer(el, cls) {
    if (!el) return;
    el.classList.add(cls || 'is-open');
    el.setAttribute('aria-hidden', 'false');
    openLayers.push([el, cls || 'is-open']);
    scrimOn();
  }
  function closeLayer(el, cls) {
    if (!el) return;
    el.classList.remove(cls || 'is-open');
    el.setAttribute('aria-hidden', 'true');
    openLayers = openLayers.filter(function (p) { return p[0] !== el; });
    if (!openLayers.length) scrimOff();
  }
  function closeAll() {
    openLayers.slice().forEach(function (p) { closeLayer(p[0], p[1]); });
    var mn = $('#mobileNav'); if (mn) mn.classList.remove('is-open');
    scrimOff();
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'scrim') closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ---------------- cart drawer ---------------- */
  function drawer() { return $('#cartDrawer'); }
  function openCart() { openLayer(drawer(), 'is-open'); }

  function refreshCartUI() {
    return fetch(root + '/?sections=cart-drawer,header', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var fresh = tmp.querySelector('#cartDrawer');
          var old = drawer();
          if (fresh && old) {
            /* Update only the cart-derived regions in place. The #cartDrawer node itself is NOT
               replaced, and #drawerAltCheckouts is never touched: Shopify does not output
               content_for_additional_checkout_buttons inside Section Rendering API responses, so
               re-rendering that container would blank the Shop Pay / PayPal / Google Pay / Apple Pay
               buttons after a cart update. Keeping the node alive also avoids duplicate buttons and
               keeps the drawer's open state and focus intact. */
            ['#drawerBody', '#drawerFootTop', '#drawerFootBottom'].forEach(function (sel) {
              var target = old.querySelector(sel), source = fresh.querySelector(sel);
              if (target && source) target.innerHTML = source.innerHTML;
            });
            var srcCount = fresh.querySelector('#cartCountSource');
            var count = srcCount ? parseInt(srcCount.textContent, 10) || 0 : 0;
            var wallets = old.querySelector('#drawerAltCheckouts');
            if (wallets) wallets.style.display = count > 0 ? '' : 'none';
            var oldCountSrc = old.querySelector('#cartCountSource');
            if (oldCountSrc) oldCountSrc.textContent = String(count);
            bindDrawer();
          }
        }
        if (data.header) {
          var t2 = document.createElement('div');
          t2.innerHTML = data.header;
          var freshCount = t2.querySelector('#cartCount');
          var oldCount = $('#cartCount');
          if (freshCount && oldCount) {
            oldCount.textContent = freshCount.textContent;
            oldCount.classList.toggle('is-on', parseInt(freshCount.textContent, 10) > 0);
          }
        }
        if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) { try { window.affirm.ui.refresh(); } catch (err) {} }
      })
      .catch(function () {});
  }

  function cartChange(body) {
    return fetch(root + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(refreshCartUI);
  }

  function addItems(items, label) {
    var btns = $$('[data-adding]');
    return fetch(root + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add that'); });
      return r.json();
    }).then(function () {
      return refreshCartUI();
    }).then(function () {
      toast(label || 'Added to cart');
      openCart();
    }).catch(function (err) {
      toast(err.message || 'Sorry — that size just sold out');
    });
  }

  function bindDrawer() {
    var d = drawer();
    if (!d) return;
    var close = $('#drawerClose', d);
    if (close) close.onclick = function () { closeLayer(d, 'is-open'); };

    $$('.line', d).forEach(function (line) {
      var key = line.getAttribute('data-key');
      var qtyEl = $('.stepper span', line);
      var q = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
      var dec = $('[data-dec]', line), inc = $('[data-inc]', line), rm = $('[data-remove]', line);
      if (dec) dec.onclick = function () { cartChange({ id: key, quantity: Math.max(0, q - 1) }); };
      if (inc) inc.onclick = function () { cartChange({ id: key, quantity: q + 1 }); };
      if (rm) rm.onclick = function () { cartChange({ id: key, quantity: 0 }); };
    });
  }
  bindDrawer();

  var cartBtn = $('#cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });

  /* ---------------- size guide ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sizeguide]');
    if (t) { e.preventDefault(); openLayer($('#sizeGuide'), 'is-open'); }
    if (e.target.closest && e.target.closest('#sizeGuideClose')) closeLayer($('#sizeGuide'), 'is-open');
  });

  /* ---------------- header: mobile nav + search ---------------- */
  var burger = $('#burgerBtn'), mobileNav = $('#mobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
      open ? scrimOn() : scrimOff();
    });
  }
  var mobileNavClose = $('#mobileNavClose');
if (mobileNavClose && mobileNav) {
  mobileNavClose.addEventListener('click', function () {
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    scrimOff();
  });
}
/* ---------------- header: search ---------------- */

var searchBtn = $('#searchBtn');
var searchPanel = $('#searchPanel');

var searchInput = $('#searchInput');
var searchResults = $('#searchResults');

var searchClear = $('#searchClear');

var recentSearches = $('#recentSearches');
var recentSearchList = $('#recentSearchList');
var clearRecentSearches = $('#clearRecentSearches');

var searchTimer;

var RECENT_SEARCH_KEY = 'pm_recent_searches';
var MAX_RECENT_SEARCHES = 5;


/* Get recent searches */
function getRecentSearches() {
  try {
    return JSON.parse(
      localStorage.getItem(RECENT_SEARCH_KEY)
    ) || [];
  } catch (e) {
    return [];
  }
}


/* Show recent searches */
function showRecentSearches() {

  if (!recentSearches || !recentSearchList) return;

  var searches = getRecentSearches();

  recentSearchList.innerHTML = '';

  if (!searches.length) {
    recentSearches.hidden = true;
    return;
  }

  searches.forEach(function (query) {

    var item = document.createElement('div');

    item.className = 'pm-recent-search-item';

    var button = document.createElement('button');

    button.type = 'button';
    button.className = 'pm-recent-search-query';

    button.innerHTML =
      '<span class="pm-recent-search-icon">↻</span>' +
      '<span class="pm-recent-search-text"></span>';

    button.querySelector(
      '.pm-recent-search-text'
    ).textContent = query;

    button.addEventListener('click', function () {

      searchInput.value = query;

      recentSearches.hidden = true;

      searchInput.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      searchInput.focus();

    });

    item.appendChild(button);

    recentSearchList.appendChild(item);

  });

  recentSearches.hidden = false;
}


/* Save search */
function saveRecentSearch(query) {

  query = query.trim();

  if (!query) return;

  var searches = getRecentSearches();

  searches = searches.filter(function (item) {
    return item.toLowerCase() !== query.toLowerCase();
  });

  searches.unshift(query);

  searches = searches.slice(
    0,
    MAX_RECENT_SEARCHES
  );

  localStorage.setItem(
    RECENT_SEARCH_KEY,
    JSON.stringify(searches)
  );
}


/* Open search */

if (searchBtn && searchPanel) {

  searchBtn.addEventListener('click', function () {

    openLayer(
      searchPanel,
      'is-open'
    );

    if (searchInput) {

      setTimeout(function () {

        searchInput.focus();

        /* Show previous searches */
        if (!searchInput.value.trim()) {
          showRecentSearches();
        }

      }, 60);

    }

  });


  /* Close search */

  var sc = $('#searchClose');

  if (sc) {

    sc.addEventListener('click', function () {

      closeLayer(
        searchPanel,
        'is-open'
      );

      if (recentSearches) {
        recentSearches.hidden = true;
      }

    });

  }

}


/* Search input */

if (searchInput && searchResults) {

  searchInput.addEventListener('input', function () {

    var q = searchInput.value.trim();

    clearTimeout(searchTimer);


    /* Clear button */

    if (searchClear) {
      searchClear.hidden = q.length === 0;
    }


    /* Empty search */

    if (q.length === 0) {

      searchResults.innerHTML = '';

      showRecentSearches();

      return;

    }


    /* Hide recent searches while typing */

    if (recentSearches) {
      recentSearches.hidden = true;
    }


    if (q.length < 2) {

      searchResults.innerHTML = '';

      return;

    }


    searchTimer = setTimeout(function () {

      fetch(
        root +
        '/search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last'
      )

      .then(function (r) {
        return r.json();
      })

      .then(function (j) {

        var items =
          (j.resources &&
           j.resources.results &&
           j.resources.results.products) || [];


        if (!items.length) {

          searchResults.innerHTML =
            '<p class="tiny" style="padding:14px 0">' +
            'No matches yet — try a print name.' +
            '</p>';

          return;

        }


        searchResults.innerHTML =
          items.map(function (p) {

            var img =
              p.featured_image &&
              p.featured_image.url
                ? '<img src="' +
                  p.featured_image.url +
                  '" alt="" width="60" height="80" loading="lazy">'
                : '';

            return (
              '<a class="sresult" href="' +
              p.url +
              '">' +

              img +

              '<span>' +
                '<span class="sr-title">' +
                  p.title +
                '</span>' +

                '<span class="tiny">' +
                  (p.price || '') +
                '</span>' +
              '</span>' +

              '</a>'
            );

          }).join('') +

          '<a class="link-underline" style="display:inline-block;margin-top:12px" href="' +
          root +
          '/search?q=' +
          encodeURIComponent(q) +
          '">' +
          'See all results' +
          '</a>';

      })

      .catch(function () {});

    }, 200);

  });

}


/* Save search when submitted */

if (searchInput) {

  var searchForm = searchInput.closest('form');

  if (searchForm) {

    searchForm.addEventListener(
      'submit',
      function () {

        saveRecentSearch(
          searchInput.value
        );

      }
    );

  }

}


/* Clear search text */

if (searchClear && searchInput) {

  searchClear.addEventListener(
    'click',
    function () {

      searchInput.value = '';

      searchResults.innerHTML = '';

      searchClear.hidden = true;

      showRecentSearches();

      searchInput.focus();

    }
  );

}


/* Clear all recent searches */

if (clearRecentSearches) {

  clearRecentSearches.addEventListener(
    'click',
    function () {

      localStorage.removeItem(
        RECENT_SEARCH_KEY
      );

      showRecentSearches();

    }
  );

}
  /* ---------------- sticky header shadow ---------------- */
  var hdr = $('#siteHeader') || $('.site-header');
  if (hdr) {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY || 0;
      hdr.classList.toggle('is-stuck', y > 8);
      lastY = y;
    }, { passive: true });
  }

  /* ---------------- reveal on scroll ---------------- */
  var reveals = $$('.reveal');
  if (reveals.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  /* ---------------- quick add on product cards ---------------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.quick .chip');
    if (!chip || chip.disabled) return;
    var id = chip.getAttribute('data-variant');
    if (!id) return;
    e.preventDefault();
    chip.classList.add('is-loading');
    addItems([{ id: Number(id), quantity: 1 }]).then(function () { chip.classList.remove('is-loading'); });
  });

  /* ---------------- collection: filters ---------------- */
  var filterForm = $('#filterForm');
  if (filterForm) {
    var submitting = false;
    var submitFilters = function () {
      if (submitting) return;
      submitting = true;
      var params = new URLSearchParams(new FormData(filterForm));
      var sort = $('#sortSelect');
      if (sort) { params.delete('sort_by'); if (sort.value) params.set('sort_by', sort.value); }
      var qs = params.toString().replace(/(^|&)[^=&]+=(?=&|$)/g, '').replace(/^&+|&+$/g, '');
      window.location.search = qs;
    };
    filterForm.addEventListener('change', submitFilters);
    var sortSel = $('#sortSelect');
    if (sortSel) sortSel.addEventListener('change', submitFilters);
    var apply = $('#filtersApply');
    if (apply) apply.addEventListener('click', submitFilters);

    $$('.fhead', filterForm).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grp = btn.closest('.fgroup');
        var open = grp.getAttribute('data-open') === 'true';
        grp.setAttribute('data-open', String(!open));
        btn.setAttribute('aria-expanded', String(!open));
        var mk = $('.marker', btn); if (mk) mk.textContent = open ? '+' : '–';
      });
    });
  }
  var fOpen = $('#filtersOpen'), fClose = $('#filtersClose'), fRail = $('#filters');
  if (fOpen && fRail) fOpen.addEventListener('click', function () { fRail.classList.add('is-open'); fOpen.setAttribute('aria-expanded', 'true'); scrimOn(); });
  if (fClose && fRail) fClose.addEventListener('click', function () { fRail.classList.remove('is-open'); if (fOpen) fOpen.setAttribute('aria-expanded', 'false'); scrimOff(); });

  /* ---------------- product page ---------------- */
  var pdp = $('#pdp');
  if (pdp) {
    var stage = $('#stageImg');
    var stageVideo = $('#stageVideo');
    var stageHint = $('#stageHint');
    var thumbs = $$('.thumbs button', pdp);

    function showImage(src, fullSrc, alt) {
      if (stageVideo) {
        stageVideo.pause();
        stageVideo.style.display = 'none';
      }
      if (stage) {
        stage.style.display = '';
        stage.src = src;
        stage.setAttribute('data-full', fullSrc || src);
        stage.alt = alt;
      }
      if (stageHint) { stageHint.style.display = ''; stageHint.textContent = 'Click to enlarge'; }
    }

    function showVideo(videoSrc, posterSrc, alt) {
      if (stage) stage.style.display = 'none';
      if (stageVideo) {
        stageVideo.style.display = '';
        if (stageVideo.getAttribute('src') !== videoSrc) {
          stageVideo.setAttribute('poster', posterSrc || '');
          stageVideo.setAttribute('src', videoSrc);
          stageVideo.setAttribute('aria-label', alt || '');
        }
        var playPromise = stageVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () { /* autoplay blocked; controls let the shopper press play */ });
        }
      }
      if (stageHint) { stageHint.style.display = 'none'; }
    }

    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
        var im = $('img', b);
        var videoSrc = b.getAttribute('data-video-src');
        var fullSrc = b.getAttribute('data-full') || (im && im.src);
        if (b.getAttribute('data-type') === 'video' && videoSrc) {
          showVideo(videoSrc, fullSrc, im && im.alt);
        } else if (im) {
          showImage(fullSrc, fullSrc, im.alt);
        }
      });
    });

    var lightbox = $('#lightbox'), lightboxImg = $('#lightboxImg');
    if (stage && lightbox) {
      stage.style.cursor = 'zoom-in';
      stage.addEventListener('click', function () {
        if (stage.style.display === 'none') return;
        lightboxImg.src = stage.getAttribute('data-full') || stage.src;
        lightboxImg.alt = stage.alt;
        openLayer(lightbox, 'is-open');
      });
      var lbc = $('#lightboxClose');
      if (lbc) lbc.addEventListener('click', function () { closeLayer(lightbox, 'is-open'); });
    }

    var variantInput = $('#pdpVariantId');
    var addBtn = $('#addBtn');
    var addPrice = $('#addPrice');
    var pdpPrice = $('#pdpPrice');
    var sizeEcho = $('#sizeEcho');
    var sizeErr = $('#sizeErr');
    var stickyMeta = $('#stickyMeta');
    var chosen = null;

    var vdEl = document.getElementById('pdpVariantData');
    var pdpVariants = [];
    if (vdEl) { try { pdpVariants = JSON.parse(vdEl.textContent); } catch (err) { pdpVariants = []; } }

    var optRows = $$('#sizeOpt .opt-row');
        if (!optRows.length && pdpVariants.length) {
  var initialId = variantInput ? Number(variantInput.value) : null;
  chosen = pdpVariants.filter(function (v) { return v.id === initialId; })[0] || pdpVariants[0];
}

    var selState = {};

    function matchVariant(state, needAvailable) {
      var keys = Object.keys(state);
      for (var i = 0; i < pdpVariants.length; i++) {
        var v = pdpVariants[i];
        if (needAvailable && !v.a) continue;
        var ok = true;
        for (var k = 0; k < keys.length; k++) {
          if (v.o[parseInt(keys[k], 10) - 1] !== state[keys[k]]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

       
function allChosen() {
  if (!optRows.length) return true;
  for (var i = 0; i < optRows.length; i++) {
    if (!selState[optRows[i].getAttribute('data-optrow')]) return false;
  }
  return true;
}


    function labelText() {
      var parts = [];
      optRows.forEach(function (row) {
        var p = row.getAttribute('data-optrow');
        if (selState[p]) parts.push(selState[p]);
      });
      return parts.join(' / ');
    }

    function refreshAvailability() {
      optRows.forEach(function (row) {
        var pos = row.getAttribute('data-optrow');
        var others = {};
        Object.keys(selState).forEach(function (k) { if (k !== pos) others[k] = selState[k]; });
        $$('.chip', row).forEach(function (chip) {
          var test = {};
          Object.keys(others).forEach(function (k) { test[k] = others[k]; });
          test[pos] = chip.getAttribute('data-value');
          var hit = matchVariant(test, true);
          if (hit) {
            chip.disabled = false;
            chip.classList.remove('is-oos');
            chip.removeAttribute('aria-label');
          } else {
            chip.disabled = true;
            chip.classList.add('is-oos');
            chip.setAttribute('aria-label', chip.getAttribute('data-value') + ' \u2014 sold out');
          }
        });
      });
    }

    function applyVariant(v) {
      chosen = v;
      if (variantInput) variantInput.value = String(v.id);
      var money = v.pm;
      var lbl = labelText();
      if (addPrice && money) addPrice.textContent = money;
      if (pdpPrice && money) pdpPrice.textContent = money;
      if (stickyMeta && money) stickyMeta.textContent = lbl + ' \u00b7 ' + money;
      if (sizeErr) sizeErr.style.display = 'none';
      var bts = $('#bundleThisSize');
      if (bts) bts.textContent = 'Size: ' + lbl;
      var af = $('#affirmSlot');
      if (af) {
        af.setAttribute('data-amount', String(v.p));
        if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) { try { window.affirm.ui.refresh(); } catch (err) {} }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(v.id));
      window.history.replaceState({}, '', url);
      recalcBundle();
    }

    function selectChip(chip) {
      var row = chip.closest('.opt-row');
      var pos = row.getAttribute('data-optrow');
      $$('.chip', row).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); c.classList.remove('is-on'); });
      chip.setAttribute('aria-pressed', 'true');
      chip.classList.add('is-on');
      selState[pos] = chip.getAttribute('data-value');
      var echo = $('[data-sizeecho="' + pos + '"]');
      if (echo) echo.textContent = '\u2014 ' + selState[pos];
      refreshAvailability();
      if (allChosen()) {
        var v = matchVariant(selState, true) || matchVariant(selState, false);
        if (v) applyVariant(v);
      } else {
        chosen = null;
      }
    }

    optRows.forEach(function (row) {
      $$('.chip', row).forEach(function (chip) {
        chip.addEventListener('click', function () { if (!chip.disabled) selectChip(chip); });
      });
    });
    refreshAvailability();

    var qty = 1;
    var qVal = $('#qVal'), qInput = $('#pdpQty');
    function setQty(n) {
      qty = Math.max(1, Math.min(10, n));
      if (qVal) qVal.textContent = String(qty);
      if (qInput) qInput.value = String(qty);
    }
    var qd = $('#qDec'), qi = $('#qInc');
    if (qd) qd.addEventListener('click', function () { setQty(qty - 1); });
    if (qi) qi.addEventListener('click', function () { setQty(qty + 1); });

    var form = $('#pdpForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!chosen) {
          if (sizeErr) sizeErr.style.display = 'block';
          var so = $('#sizeOpt'); if (so) so.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (addBtn) addBtn.classList.add('is-loading');
        addItems([{ id: Number(variantInput.value), quantity: qty }]).then(function () {
          if (addBtn) addBtn.classList.remove('is-loading');
        });
      });
    }

    var stickyAdd = $('#stickyAdd');
    if (stickyAdd) stickyAdd.addEventListener('click', function () {
      if (!chosen) { closeAll(); var so = $('#sizeOpt'); if (so) so.scrollIntoView({ behavior: 'smooth', block: 'center' }); toast('Pick a size first'); return; }
      addItems([{ id: Number(variantInput.value), quantity: qty }]);
    });

    var stickyBuy = $('#stickyBuy'), buyActions = $('.buy-actions');
    if (stickyBuy && buyActions && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (en) {
        stickyBuy.setAttribute('aria-hidden', String(en[0].isIntersecting));
        stickyBuy.classList.toggle('is-on', !en[0].isIntersecting);
      }, { threshold: 0 });
      sio.observe(buyActions);
    }

    /* bundle */
    function recalcBundle() {
      var wrap = $('.bundle');
      if (!wrap) return;
      var total = chosen ? parseInt(chosen.p, 10) : 0;
      var n = chosen ? 1 : 0;
      $$('.bundle-item[data-h]', wrap).forEach(function (it) {
        var inc = $('[data-binc]', it);
        if (inc && inc.checked) { total += parseInt(it.getAttribute('data-price'), 10) || 0; n += 1; }
      });
      var tEl = $('#bundleTotal'), cEl = $('#bundleCount');
      if (tEl) tEl.textContent = formatMoney(total);
      if (cEl) cEl.textContent = '(' + n + ' item' + (n === 1 ? '' : 's') + ')';
    }
    $$('.bundle [data-binc]').forEach(function (cb) { cb.addEventListener('change', recalcBundle); });
    recalcBundle();

    var bundleAdd = $('#bundleAdd');
    if (bundleAdd) bundleAdd.addEventListener('click', function () {
      var items = [];
      if (chosen) items.push({ id: Number(variantInput.value), quantity: 1 });
      $$('.bundle-item[data-h]').forEach(function (it) {
        var inc = $('[data-binc]', it), sel = $('[data-bsize]', it);
        if (inc && inc.checked && sel && sel.value) items.push({ id: Number(sel.value), quantity: 1 });
      });
      if (!items.length) { toast('Pick a size first'); return; }
      addItems(items, items.length + ' pieces added');
    });

    /* recommendations */
    var recGrid = $('#alsoGrid');
    if (recGrid && !recGrid.children.length) {
      var pid = recGrid.getAttribute('data-recs');
      var rurl = recGrid.getAttribute('data-recs-url') || (root + '/recommendations/products');
      fetch(rurl + '?section_id=related-products&product_id=' + pid + '&limit=4')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#alsoGrid');
          if (fresh && fresh.children.length) recGrid.innerHTML = fresh.innerHTML;
          else recGrid.closest('section').remove();
        }).catch(function () {});
    }
  }

  /* ---------------- shop the look ---------------- */
  var lookAdd = $('#lookAdd');
  if (lookAdd) {
    lookAdd.addEventListener('click', function () {
      var items = $$('#lookList .look-row').map(function (r) {
        return { id: Number(r.getAttribute('data-look-variant')), quantity: 1 };
      }).filter(function (i) { return i.id; });
      if (!items.length) return;
      addItems(items, 'The whole look is in your cart');
    });
    $$('#lookList .look-row').forEach(function (r) {
      r.addEventListener('click', function (e) { if (e.target.closest('.look-row')) { /* follow link */ } });
    });
  }

  /* ---------------- cart page steppers ---------------- */
  $$('.cart-line').forEach(function (line) {
    var input = $('[data-qty-input]', line);
    var dn = $('[data-qty-down]', line), up = $('[data-qty-up]', line);
    var form = $('#cartForm');
    function bump(delta) {
      if (!input) return;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      if (form) form.submit();
    }
    if (dn) dn.addEventListener('click', function () { bump(-1); });
    if (up) up.addEventListener('click', function () { bump(1); });
  });

  /* ---------------- money ---------------- */
  function formatMoney(cents) {
    var fmt = PM.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1,');
    var withCents = parts.join('.');
    var noCents = parts[0];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCents)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noCents)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCents.replace('.', ',').replace(/,(\d\d\d)/g, '.$1'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noCents);
  }
  window.PMformatMoney = formatMoney;
})();
